import { useCallback } from 'react';
import { ZxyOpenApiMethodsKeys, ZxyOpenApiPathAndOperationParameter, ZxyOpenApiPathsKeys } from '../../../common/src/routes/openApiTypes';
import { useReactAsync } from '../components/utils/useReactAsync';
import { openApiFetch } from './openApiFetch';

export function useOpenApiFetch<
    Path extends ZxyOpenApiPathsKeys,
    Method extends ZxyOpenApiMethodsKeys<Path>,
    PathMethodParameters extends ZxyOpenApiPathAndOperationParameter<Path, Method>,
>(path: Path, method: Method, parameters: PathMethodParameters, deps: undefined | React.DependencyList = []) {
    const getData = useCallback(async () => {
        const result = await openApiFetch(path, method, parameters, undefined as any);
        return result;

        // eslint-disable-next-line react-hooks/exhaustive-deps -- parameters is an object and should not be compared by reference
    }, [method, JSON.stringify(parameters), path]);

    return useReactAsync(getData, {}, deps);
}
